// @flow
import axios from 'axios';

import config from 'config';

const { tmsEndPoint } = config;
export const instance = axios.create({
    baseURL: tmsEndPoint,
});
